import {useLazyQuery} from '@apollo/client'
import {GET_ALL_CUSTOMERS_BY_SYSTEM_ADMIN} from '../../../utils/GraphQLAPI'
import SearchList from '../../sharedComponent/SearchList/SearchList'
import {useEffect, useRef, useState} from 'react'
import {LEADGENCUSTOMERLISTCONFIGS} from './CustomerListConfigs'
import {GLOBAL_CONSTANTS} from '../../../utils/GlobalConstants'
import DownloadCsv from '../Download/DownloadCsv'
import moment from 'moment'
import uuid from 'react-uuid'

const CustomerList = () => {
  const [getAllCustomersBySystemadmin, {data, loading}] = useLazyQuery(
    GET_ALL_CUSTOMERS_BY_SYSTEM_ADMIN,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      onCompleted: (data) => {
        setDownloadData(
          data.getAllCustomersBySystemAdmin.customers.map((customer: any) => {
            console.log(customer, 'custoemrrr')
            return {
              ...customer,
              listId: uuid(),
              isOpted: customer.isOpted ? 'Subscribed' : 'Unsubscribed',
              smsOptedTime: moment.utc(customer.smsOptedTime).local().format('ll, hh:mm A'),
              primaryPhoneNumber: Number(customer.primaryPhoneNumber),
            }
          })
        )
      },
    }
  )
  const [downloadData, setDownloadData] = useState([])
  const [apiInput, setApiInput] = useState({
    page: 1,
    perPage: 10,
  })
  const csvRef = useRef<any>(null)
  const csvHeader = [
    {label: 'Customer Phone Number', key: 'primaryPhoneNumber'},
    {label: 'Link Status', key: 'appInstalledStatus'},
    {label: 'Sent Date/Time', key: 'smsOptedTime'},
    {label: 'Subscription Status', key: 'isOpted'},
  ]
  const csvDownloadFun = async () => {
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  useEffect(() => {
    getAllCustomersBySystemadmin({
      variables: {
        customerListInput: apiInput,
      },
    })
  }, [apiInput])
  console.log('download data', downloadData)
  return (
    <SearchList
      filterOptions={apiInput}
      setFilterOptions={setApiInput}
      listLoading={loading}
      listConfigs={LEADGENCUSTOMERLISTCONFIGS}
      listCount={data?.getAllCustomersBySystemAdmin?.totalCount}
      paginatedCount={data?.getAllCustomersBySystemAdmin?.customers.length}
      apiData={data?.getAllCustomersBySystemAdmin?.customers}
      idFieldName='id'
      isActiveApiFieldName=''
      isSearchable={true}
      searchKey='mobileNumber'
      toolbar={
        <>
          {data?.getAllCustomersBySystemAdmin?.totalCount !== 0 && (
            <DownloadCsv
              csvDownloadFun={csvDownloadFun}
              reload={loading}
              csvHeaders={csvHeader}
              csvRef={csvRef}
              downloadData={downloadData}
              downloadFileName='customers.csv'
            />
          )}
        </>
      }
    />
  )
}

export default CustomerList
